// src/utils/api.js
import axios from "axios";

const API = axios.create({
  baseURL: "https://alkebulanfkalertbackend.onrender.com/api",
  withCredentials: false,
});

// ✅ Attach token automatically if it exists
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ---------- AUTH ----------
export const login = (data) => API.post("/auth/login", data);
export const register = (data) => API.post("/auth/register", data);

// ---------- WEBAUTHN (BIOMETRICS) ----------
export const startRegistration = (email) =>
  API.post("/auth/webauthn/register/start", { email });

export const verifyRegistration = (email, attResp) =>
  API.post("/auth/webauthn/register/verify", { email, attResp });

export const startAuthentication = (email) =>
  API.post("/auth/webauthn/authenticate/start", { email });

export const verifyAuthentication = (email, authResp) =>
  API.post("/auth/webauthn/authenticate/verify", { email, authResp });

export const resetBiometric = (email) =>
  API.post("/auth/webauthn/reset", { email });

// ---------- USERS ----------
export const getUserByEmail = (email) =>
  API.get(`/users?email=${encodeURIComponent(email)}`);

export default API;
